var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_7055)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_46_7055)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.3892 16.4469C21.1092 17.1969 20.5192 17.7669 19.7492 18.0269C18.6692 18.3869 17.5592 18.6569 16.4392 18.8469C16.3292 18.8669 16.2192 18.8869 16.1092 18.8969C15.9292 18.9269 15.7492 18.9469 15.5692 18.9669C15.3492 18.9969 15.1192 19.0169 14.8892 19.0369C14.2592 19.0869 13.6392 19.1169 13.0092 19.1169C12.3692 19.1169 11.7292 19.0869 11.0992 19.0269C10.8292 19.0069 10.5692 18.9769 10.3092 18.9369C10.1592 18.9169 10.0092 18.8969 9.86922 18.8769C9.75922 18.8569 9.64922 18.8469 9.53922 18.8269C8.42922 18.6469 7.32922 18.3769 6.25922 18.0169C5.45922 17.7469 4.84922 17.1769 4.57922 16.4469C4.30922 15.7269 4.40922 14.8869 4.83922 14.1669L5.96922 12.2869C6.20922 11.8769 6.42922 11.0869 6.42922 10.6069V8.74686C6.42922 5.11686 9.37922 2.16687 13.0092 2.16687C16.6292 2.16687 19.5792 5.11686 19.5792 8.74686V10.6069C19.5792 11.0869 19.7992 11.8769 20.0492 12.2869L21.1792 14.1669C21.5892 14.8669 21.6692 15.6869 21.3892 16.4469Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9892 10.8806C12.5692 10.8806 12.2292 10.5406 12.2292 10.1206V7.02063C12.2292 6.60063 12.5692 6.26062 12.9892 6.26062C13.4092 6.26062 13.7492 6.60063 13.7492 7.02063V10.1206C13.7392 10.5406 13.3992 10.8806 12.9892 10.8806Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8187 20.13C15.3987 21.29 14.2887 22.12 12.9887 22.12C12.1987 22.12 11.4187 21.8 10.8687 21.23C10.5487 20.93 10.3087 20.53 10.1687 20.12C10.2987 20.14 10.4287 20.15 10.5687 20.17C10.7987 20.2 11.0387 20.23 11.2787 20.25C11.8487 20.3 12.4287 20.33 13.0087 20.33C13.5787 20.33 14.1487 20.3 14.7087 20.25C14.9187 20.23 15.1287 20.22 15.3287 20.19C15.4887 20.17 15.6487 20.15 15.8187 20.13Z",
    fill: "#347D73"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_7055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.989014 0.119995)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_46_7055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.989014 0.119995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon01);
export default __webpack_public_path__ + "static/media/note-icon-01.b93374dcdc463bb3dc071ff0853f3a85.svg";
export { ForwardRef as ReactComponent };